define(
    'views/newsletter-subscribe-block-view',[
        'jquery',
        'utils/view',
        'utils/form-validator',
    ],

    function ($, View, FormValidator) {
        var NewsletterSubscribeBlockView = (function () {

            function NewsletterSubscribeBlockView (container) {
                var _this = this;
                _this.container = container;

                _this.container.find('form').each(function() {
                    _this.initForm($(this));
                });
            }

            NewsletterSubscribeBlockView.prototype.initForm = function ($form) {
                var formValidator = new FormValidator($form);
                formValidator.enableValidMsg(true);
                formValidator.removeInputErrorMsgOn('keypress');
                formValidator.validateInputOn('change');

                $form.on('submit', function(e) {
                    if (! formValidator.validateForm() ) {
                        e.preventDefault();
                    }
                });
            };

            return NewsletterSubscribeBlockView;
        })();

        return View('NewsletterSubscribe', function () {
            var view = new NewsletterSubscribeBlockView($('[data-view="NewsletterSubscribe"]'));
        });
    }
);
